import { useEffect } from 'react';
import { connect } from 'react-redux';

import * as selectors from '../../../multiLoanDashboard/accountsSelector';

import { MainSectionWrapper } from '../../../pageStructure/mainSectionWrapper/MainSectionWrapper';
import { TitleSectionWrapper } from '../../../pageStructure/titleSectionWrapper/TitleSectionWrapper';
import { CreditOutstanding } from '../../../ui/creditUtilisation/creditOutstanding/CreditOutstanding';
import { MoneyWithDecimals } from '../../../ui/moneyWithDecimals/MoneyWithDecimals';
import ActionButtonMakeRepayment from '../../../multiLoanDashboard/dashboardComponents/actionButtonMakeRepayment/ActionButtonMakeRepayment';
import AccountsStatusLinesWithLoan from '../../../multiLoanDashboard/dashboardComponents/AccountsStatusLinesWithLoan';
import InternationalisedName from '../../../multiLoanDashboard/dashboardComponents/InternationalisedName';

import styles from './OngoingLoanView.module.css';
import { RLS_PRODUCT_TYPE } from '../dashboardSelectors';
import { tracking } from '@iwoca/frontend-tracking-library';

const mapStateToProps = (state) => ({
    approvalStatusPrincipalBalance: selectors.getOutstandingPrincipal(
        state,
        RLS_PRODUCT_TYPE
    ),
    approvalStatusInterestBalance: selectors.getOutstandingInterest(
        state,
        RLS_PRODUCT_TYPE
    ),
    approvalStatusFeesBalance: selectors.getOutstandingFees(
        state,
        RLS_PRODUCT_TYPE
    ),
    approvalInterestRate: selectors.getMaxMonthlyInterestRate(
        state,
        RLS_PRODUCT_TYPE
    ),
    outstandingBalance: selectors.getOutstandingTotal(state, RLS_PRODUCT_TYPE),
    accountId: selectors.getAccountId(state, RLS_PRODUCT_TYPE)
});

const OngoingLoanView = ({
    approvalStatusPrincipalBalance,
    approvalStatusInterestBalance,
    approvalStatusFeesBalance,
    approvalInterestRate,
    outstandingBalance,
    accountId
}) => {
    useEffect(() => {
        tracking.ampli.dashboardViewed({
            account_id: accountId,
            product_type: 'recovery_loan',
            dashboard_state: 'ongoing'
        });
    }, [accountId]);

    return (
        <>
            <TitleSectionWrapper withBackground={true}>
                <div data-testid="headlineText" className={styles.Headline}>
                    Hi <InternationalisedName />, your outstanding balance is{' '}
                    <MoneyWithDecimals
                        value={outstandingBalance}
                        decimalWithSeparatorClassName={
                            styles.decimalsWithSeparator
                        }
                    />
                </div>

                <AccountsStatusLinesWithLoan productType={RLS_PRODUCT_TYPE} />

                <CreditOutstanding
                    approvalInterestRate={approvalInterestRate}
                    approvalStatusFeesBalance={approvalStatusFeesBalance}
                    approvalStatusInterestBalance={
                        approvalStatusInterestBalance
                    }
                    approvalStatusPrincipalBalance={
                        approvalStatusPrincipalBalance
                    }
                />
            </TitleSectionWrapper>

            <MainSectionWrapper>
                <ActionButtonMakeRepayment
                    outstandingBalance={outstandingBalance}
                    accountId={accountId}
                />
            </MainSectionWrapper>
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(OngoingLoanView);
